const state = {
    resellers: [],
    endClients: []
  };
  
  const mutations = {
    setResellers(state, payload) {
      state.resellers = payload;
    },
    setEndClients(state, payload) {
      state.endClients = payload;
    }
  };
  
  const actions = {
    async fetchResellers({ state, commit }) {
      if (state.resellers.length > 0) return; // ✅ gebruik bestaande data
 
        const { result } = await this.$xhr.get('/api/getallresellers');
        const modifiedResult = [{ id: null, name: 'Alle resellers' }, ...result];
        commit('setResellers', modifiedResult);
   
    },
  
    async fetchEndClients({ state, commit }) {
      if (state.endClients.length > 0) return; // ✅ gebruik bestaande data
  
    const { result } = await this.$xhr.get('/api/getallendcustomers');
    const modifiedResult = [{ id: null, name: 'Alle eindklanten' }, ...result];
    commit('setEndClients', modifiedResult);
      
    }
  };
  
  const getters = {
    allResellers: state => state.resellers,
    allEndClients: state => state.endClients
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  };
  